import {
  ADD_NOTIFICATION_START,
  ADD_NOTIFICATION_ERROR,
  ADD_NOTIFICATION_SUCCESS,
} from 'constants/action-types/users/notifications';

import apiAction from 'helpers/apiAction';

const { REACT_APP_REAL_TIME_SERVICES_URL } = process.env;

export default data => dispatch =>
  dispatch(
    apiAction({
      httpOptions: {
        url: `${REACT_APP_REAL_TIME_SERVICES_URL}/api`,
        headers: {
          'rts-access-token': localStorage.rtsToken,
        },
      },
      method: 'POST',
      url: '/notifications',
      data,
      onStart: () => dispatch =>
        dispatch({
          type: ADD_NOTIFICATION_START,
          payload: data,
        }),
      onSuccess: data => dispatch => {
        return dispatch({
          type: ADD_NOTIFICATION_SUCCESS,
          payload: {
            ...data,
          },
        });
      },
      onFailure: error => dispatch => {
        return dispatch({
          type: ADD_NOTIFICATION_ERROR,
          payload: {
            error,
          },
        });
      },
    }),
  );
